import { render, staticRenderFns } from "./Logistica.vue?vue&type=template&id=0c9f8efa&scoped=true"
import script from "./Logistica.vue?vue&type=script&lang=js"
export * from "./Logistica.vue?vue&type=script&lang=js"
import style0 from "./Logistica.vue?vue&type=style&index=0&id=0c9f8efa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9f8efa",
  null
  
)

export default component.exports